import { render, staticRenderFns } from "./ApplicationSubmitSuccess.vue?vue&type=template&id=30befb8d&scoped=true"
import script from "./ApplicationSubmitSuccess.vue?vue&type=script&lang=ts"
export * from "./ApplicationSubmitSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30befb8d",
  null
  
)

export default component.exports